import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminOverlayComponent, DefaultFullOverlayComponent, DefaultOverlayComponent } from '@core/modules/layout/components';
import { AuthGuard, NonAuthGuard } from '@core/guards';
import {
    AUDIT_ROUTE_MODULE,
    CORRECTION_FORM_MODULE,
    DASHBOARD_ROUTE_MODULE,
    DICTIONARY_ROUTE_MODULE,
    ERROR_PAGES_404_ROUTE,
    ERROR_PAGES_ROUTE_MODULE,
    MATERIAL_ROUTE_MODULE,
    MESSAGES_ROUTE_MODULE,
    NON_CONFORMITIES_ROUTE_MODULE,
    SETTINGS_ROUTE_MODULE,
    SUPPLIER_ROUTE_MODULE,
} from '@core/constants/navigation/navigation.const';

const routes: Routes = [
    {
        path: '',
        component: DefaultOverlayComponent,
        canActivate: [NonAuthGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./core/modules/authentication/authentication.module').then(m => m.AuthenticationModule)
            },
        ]
    },
    {
        path: '',
        component: DefaultFullOverlayComponent,
        children: [
            {
                path: CORRECTION_FORM_MODULE,
                loadChildren: () => import('./modules/correction-form/correction-form.module').then(m => m.CorrectionFormModule)
            }
        ]
    },
    {
        path: '',
        component: AdminOverlayComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: DASHBOARD_ROUTE_MODULE,
                loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
            },
            {
                path: SETTINGS_ROUTE_MODULE,
                loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
            },
            {
                path: SETTINGS_ROUTE_MODULE,
                loadChildren: () => import('./modules/subscription/subscription.module').then(m => m.SubscriptionModule),
            },
            {
                path: MESSAGES_ROUTE_MODULE,
                loadChildren: () => import('@modules/messages/messages.module').then(m => m.MessagesModule),
            },
            {
                path: AUDIT_ROUTE_MODULE,
                loadChildren: () => import('./modules/audit/audit.module').then(m => m.AuditModule),
            },
            {
                path: NON_CONFORMITIES_ROUTE_MODULE,
                loadChildren: () => import('./modules/non-conformities/non-conformities.module').then(m => m.NonConformitiesModule),
            },
            {
                path: SUPPLIER_ROUTE_MODULE,
                loadChildren: () => import('./modules/supplier/supplier.module').then(m => m.SupplierModule),
            },
            {
                path: MATERIAL_ROUTE_MODULE,
                loadChildren: () => import('./modules/material/material.module').then(m => m.MaterialModule),
            },
            {
                path: DICTIONARY_ROUTE_MODULE,
                loadChildren: () => import('./modules/dictionary/dictionary.module').then(m => m.DictionaryModule),
            },
        ]
    },
    {
        path: ERROR_PAGES_ROUTE_MODULE,
        loadChildren: () => import('./core/modules/error-pages/error-pages.module').then(m => m.ErrorPagesModule),
    },
    {
        path: '**',
        redirectTo: ERROR_PAGES_404_ROUTE,
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
